import React, { SVGProps } from "react";

const RightArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_330_1050)">
      <rect
        width="40"
        height="40"
        rx="8"
        transform="matrix(-1 0 0 1 42.1333 1.10001)"
        fill="white"
      />
      <rect
        x="-0.5"
        y="0.5"
        width="39"
        height="39"
        rx="7.5"
        transform="matrix(-1 0 0 1 41.1333 1.10001)"
        stroke="#D0D5DD"
      />
      <path
        d="M18.7494 13.145C18.515 13.3794 18.3834 13.6973 18.3834 14.0288C18.3834 14.3602 18.515 14.6781 18.7494 14.9125L24.9369 21.1L18.7494 27.2875C18.5217 27.5233 18.3957 27.839 18.3985 28.1668C18.4014 28.4945 18.5328 28.808 18.7646 29.0398C18.9964 29.2715 19.3099 29.403 19.6376 29.4058C19.9654 29.4087 20.2811 29.2827 20.5169 29.055L27.5881 21.9838C27.8225 21.7493 27.9541 21.4315 27.9541 21.1C27.9541 20.7685 27.8225 20.4507 27.5881 20.2163L20.5169 13.145C20.2825 12.9107 19.9646 12.779 19.6331 12.779C19.3017 12.779 18.9838 12.9107 18.7494 13.145Z"
        fill="#0D57DE"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_330_1050"
        x="0.133301"
        y="0.100006"
        width="44"
        height="44"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_330_1050"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_330_1050"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default RightArrow;
